// extracted by mini-css-extract-plugin
export default {"carter_claim":"index-module--carter_claim--5pzk9"};